import React from 'react';
import { injectIntl } from 'react-intl-next';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import messages from '@atlaskit/editor-common/messages';
import { Avatars } from './avatars';
import { InviteToEditButton } from './invite-to-edit';
var AvatarsWithPluginState = function AvatarsWithPluginState(props) {
  var title = props.intl.formatMessage(messages.inviteToEditButtonTitle);
  var selected = props.isInviteToEditButtonSelected,
    onClick = props.inviteToEditHandler,
    Component = props.inviteToEditComponent,
    editorView = props.editorView,
    featureFlags = props.featureFlags,
    editorAnalyticsAPI = props.editorAnalyticsAPI,
    editorAPI = props.editorAPI;
  var _useSharedPluginState = useSharedPluginStateWithSelector(editorAPI, ['collabEdit'], function (states) {
      var _states$collabEditSta, _states$collabEditSta2, _states$collabEditSta3;
      return {
        sessionId: (_states$collabEditSta = states.collabEditState) === null || _states$collabEditSta === void 0 ? void 0 : _states$collabEditSta.sessionId,
        activeParticipants: (_states$collabEditSta2 = states.collabEditState) === null || _states$collabEditSta2 === void 0 ? void 0 : _states$collabEditSta2.activeParticipants,
        initialised: (_states$collabEditSta3 = states.collabEditState) === null || _states$collabEditSta3 === void 0 ? void 0 : _states$collabEditSta3.initialised
      };
    }),
    sessionId = _useSharedPluginState.sessionId,
    activeParticipants = _useSharedPluginState.activeParticipants,
    initialised = _useSharedPluginState.initialised;
  if (!initialised) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Avatars, {
    sessionId: sessionId,
    participants: activeParticipants,
    editorView: editorView,
    featureFlags: featureFlags,
    editorAnalyticsAPI: editorAnalyticsAPI,
    editorAPI: editorAPI
  }, /*#__PURE__*/React.createElement(InviteToEditButton, {
    title: title,
    selected: selected,
    onClick: onClick,
    Component: Component
  }));
};
export default injectIntl(AvatarsWithPluginState);